import { render, staticRenderFns } from "./DocumentSetSb.vue?vue&type=template&id=4746c7ce&scoped=true"
import script from "./DocumentSetSb.vue?vue&type=script&lang=js"
export * from "./DocumentSetSb.vue?vue&type=script&lang=js"
import style0 from "./DocumentSetSb.vue?vue&type=style&index=0&id=4746c7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4746c7ce",
  null
  
)

export default component.exports